const routes = {
  createBank: 'system/banks/add',
  updateBank: 'system/banks/update',
  getBanks: 'system/banks',
  updateBankStatus: 'system/banks/add',
  getExportBanks:'system/exportBanks'
};

export default routes